import axios from "axios";
import {
  demoLoginEndpoint,
  loginEndpoints,
  registerEndpoint,
} from "./apiEndPoints";
import { getToken } from "./util";

interface LoginResponse {
  token: string;
  user: Record<string, any>;
}

interface RegisterResponse {
  message: string;
  user: Record<string, any>;
}

interface DemoResponse {
  username: string;
}

interface IUserRegister
{
  firstName: string,
  lastName: string,
  username: string,
  email: string,
  companyName: string,
  country: string,
  Password: string,
  confirmPassword: string,
  referral: string,
  acceptMarketing: boolean,
  acceptPrivacy: boolean
}

const userLogin = async (
  username: string,
  password: string
): Promise<LoginResponse> => {
  try {
    const formData = new URLSearchParams();
    formData.append("username", username);
    formData.append("password", password);

    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    const response = await axios.post<LoginResponse>(
      loginEndpoints,
      formData,
      config
    );
    return response.data;
  } catch (error) {
    const err = error.response?.data;
    const message =
      typeof err === "object" && err.errorMessage
        ? err.errorMessage.replace(/\\n/g, "\n")
        : "Login failed. Please try again.";

    throw new Error(message);
  }
};

const userRegister = async (uRegister: IUserRegister): Promise<RegisterResponse> => {
  try {
    const {
      firstName,
      lastName,
      username,
      email,
      companyName,
      country,
      Password,
      referral,
      acceptMarketing,
      acceptPrivacy
    } = uRegister;
    const formData = new URLSearchParams();
    formData.append("firstname", firstName);
    formData.append("lastname", lastName);
    formData.append("username", username);
    formData.append("email", email);
    formData.append("companyName", companyName);
    formData.append("country", country);
    formData.append("password", Password);
    formData.append("referredBy", typeof referral === "string" ? referral : "");
    formData.append("subscribeToConnect", `${!!acceptMarketing}`);
    formData.append("readPrivacy", `${!!acceptPrivacy}`);

    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    const response = await axios.post<RegisterResponse>(
      registerEndpoint,
      formData,
      config
    );
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.errorMessage || error.message || "Register failed";
    throw new Error(`Register failed: ${message}`);
  }
};

const userLogout = async (): Promise<void> => {
  const userToken = getToken();
  try {
    const config = {
      headers: {
        "x-auth-token": userToken,
      },
    };

    await axios.delete(loginEndpoints, config);
  } catch (error) {
    const message =
      error.response?.data?.errorMessage || error.message || "Logout failed";
    throw new Error(`Logout failed: ${message}`);
  }
};

const demoLogin = async (): Promise<LoginResponse> => {
  try {
    const response = await axios.get<LoginResponse>(demoLoginEndpoint);
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.errorMessage ||
      error.message ||
      "Demo login failed";
    throw new Error(`Demo login failed: ${message}`);
  }
};

export { userLogin, userRegister, userLogout, demoLogin };
